import { Flex, Modal, Radio, Space } from "antd";
import { useEffect, useState } from "react";
import { CustomTitle } from "../customTitle";
import { useSelector, useDispatch } from "react-redux";
import { getUserProfileAction, updatePaymentMethod } from "../../../redux/services/auth/authServices";
import { useTranslation } from "react-i18next";
import { routes } from "../../../constants";
import { baseRouteMaker } from "../../../constants/routeConsts";
import { useNavigate } from "react-router-dom";
import { appConfig } from "../../../constants/config/appConfig";
import useLocalStorage from "../../../hooks/useLocalStorage";

const PaymentMethodDialog = ({ open, onClose }) => {
  const { t } = useTranslation("payout_details");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [currentMethod, setCurrentMethod] = useState();
  const { userSession, setUserSession } = useLocalStorage(appConfig.SESSION_USER_INFO);

  const userSelectedMethod = useSelector(
    (state) => state.auth?.loginDetails?.organization_id?.payment_type
  );

  const currentBankDetails = useSelector(
    (state) => state.auth?.loginDetails?.organization_id?.payout_details
  );

  /* loading dependencies */
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(getUserProfileAction(setUserSession))
    setCurrentMethod(userSelectedMethod);
  }, [userSelectedMethod]);


  const onChange = (e) => {
    if(currentBankDetails && currentBankDetails !== null && currentBankDetails!==undefined){
      for(const value in currentBankDetails) {
        if(currentBankDetails[value] === null || currentBankDetails[value] === undefined || currentBankDetails[value] === ""){
          navigate(baseRouteMaker(routes.UPDATE_BANK_ACCOUNT))
          return;
        }
      }
    }

    onClose(false);
    setCurrentMethod(e.target.value);

    if (e.target.value === "bank") {
      let dataToBeSent = {
        payout_details: {
          ...currentBankDetails,
        },
        payment_type: "bank",
      };
      dispatch(updatePaymentMethod(dataToBeSent, setLoading));
    } else {
      let dataToBeSent = {
        payment_type: "cash",
      };
      dispatch(updatePaymentMethod(dataToBeSent, setLoading));
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={false}
      confirmLoading={loading}
    >
      <Flex vertical gap="3rem" align="center" justify="center">
        <CustomTitle textDecoration="underline" justifyContent="center">
          <>{t("Title")}</>
        </CustomTitle>

        <Radio.Group onChange={(e) => onChange(e)} value={currentMethod}>
          <Space direction="horizontal">
            <Radio style={{ fontSize: 20 }} value={"cash"}>
              {t("Cash")}
            </Radio>
            <Radio style={{ fontSize: 20 }} value={"bank"}>
              {t("Bank")}
            </Radio>
          </Space>
        </Radio.Group>
      </Flex>
    </Modal>
  );
};

export default PaymentMethodDialog;
